import React from 'react';
import PropTypes from 'prop-types';

import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

import Button from '../../../Button';
import { useStyles } from './styles';

const FilterSelectButton = ({ children, active, ...rest }) => {
	const classes = useStyles({ active });

	return (
		<Button
			noTextTransform
			size="small"
			endIcon={<ExpandMoreIcon color={rest.disabled ? 'disabled' : 'primary'} style={{ fontSize: 22 }} />}
			className={classes.root}
			{...rest}>
			{children}
		</Button>
	);
};

FilterSelectButton.propTypes = {
	children: PropTypes.node,
	active: PropTypes.bool
};

export default FilterSelectButton;
